module.exports = __webpack_public_path__ + "img/icon_img_01.96ce2220.png";